// Module
var code = "<template>\n    <button type=\"button\" \n        class=\"btn btn-action ${toggleButtonClass} side-bar-button btn-sharp ${active ? 'btn-active' : ''}\" \n        click.trigger=\"show($event)\">\n        <span resource.bind=\"resourceText\"></span>\n    </button>\n</template>\n";
// Exports
export default code;